import http from "./http";

//
export function getShop(data) {
  return http({
    url: "/web/merchant/shop/list",
    method: "GET",
    params: data,
  });
}

export function getOptionList(data) {
  return http({
    url: "/web/platform/shopCountry/optionList",
    method: "GET",
    params: data,
  });
}

export function getShopRegionOptionList() {
  return http({
    url: "/web/platform/shopRegion/optionList",
    method: "GET",
  });
}

export function bindShop(data) {
  return http({
    url: "/web/merchant/shop/bind-shop",
    method: "POST",
    data,
  });
}

export function authShop(data) {
  return http({
    url: "/web/merchant/auth/tiktok-auth",
    method: "POST",
    data,
  });
}

export function delShop(id) {
  return http({
    url: `/web/merchant/shop/${id}`,
    method: "DELETE",
  });
}

export function selectShop(data) {
  return http({
    url: "/web/merchant/shop/selectShop",
    method: "POST",
    data,
  });
}
